// hooks/useFetchParticipants.ts
import { useEffect, useState, useCallback } from 'react';
import { getAPI } from '../services/api.service';
import { toast } from 'react-toastify';

export interface Participant {
  id?: string;
  _id?: string;
  firstname?: string;
  lastname?: string;
  email?: string;
  avatarUrl?: string; // optional
}

export const useFetchParticipants = () => {
  const [participants, setParticipants] = useState<Participant[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

    const userId = JSON.parse(String(localStorage.getItem('user')))?.id || '';


  const fetchParticipants = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getAPI<{ status?: number; data?: Participant[],message:string }>('groups/participants-by-user?userId=' + userId);
      if (res?.status === 200) {
        const payload = res.data?.data ?? res.data ?? [];
        setParticipants(Array.isArray(payload) ? payload : []);
      } else {
        const msg = res?.data?.message || 'Failed to fetch participants';
        setError(msg);
        toast.error(msg);
      }
    } catch (err: any) {
      console.error('fetch participants error', err);
      setError(err?.message || 'Failed to fetch participants');
      toast.error(err?.response?.data?.message || 'Failed to fetch participants');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchParticipants();
  }, [fetchParticipants]);

  return { participants, loading, error, refetch: fetchParticipants };
};
